/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
    Tooltip,
    TooltipBody,
} from 'react-wot-bootstrap'

export const AllocateTreasuryZeroPlayersSelectedTooltip = () => (
    <Tooltip id={AllocateTreasuryZeroPlayersSelectedTooltip.id}>
        <TooltipBody>
            <FormattedMessage
                id="clanmanagement.tooltips.allocate_treasury_zero_players_selected_body"
                defaultMessage="Чтобы распределить казну, выберите одного или нескольких игроков."
            />
        </TooltipBody>
    </Tooltip>
)
AllocateTreasuryZeroPlayersSelectedTooltip.id = 'separate-treasury-zero-players-selected-tooltip'


export const AllocateTreasuryNoResourceTooltip = () => (
    <Tooltip id={AllocateTreasuryNoResourceTooltip.id}>
        <TooltipBody>
            <FormattedMessage
                id="clanmanagement.tooltips.allocate_treasury_no_resource_body"
                defaultMessage="В казне клана нет ресурсов"
            />
        </TooltipBody>
    </Tooltip>
)
AllocateTreasuryNoResourceTooltip.id = 'separate-treasury-no-gold-tooltip'


export const ChangeRoleZeroPlayersSelectedTooltip = () => (
    <Tooltip id={ChangeRoleZeroPlayersSelectedTooltip.id}>
        <TooltipBody>
            <FormattedMessage
                id="clanmanagement.tooltips.change_role_zero_players_selected_body"
                defaultMessage="Чтобы изменить должность, выберите одного или нескольких игроков."
            />
        </TooltipBody>
    </Tooltip>
)
ChangeRoleZeroPlayersSelectedTooltip.id = 'change-role-zero-players-selected-tooltip'


export const ChangeRoleCannotChangeRoleExceptTreasurersTooltip = () => (
    <Tooltip id={ChangeRoleCannotChangeRoleExceptTreasurersTooltip.id}>
        <TooltipBody>
            <FormattedMessage
                id="clanmanagement.tooltips.change_role_cannot_change_role_except_treasurers_body"
                defaultMessage="Вы можете изменить должность только игроков в должности ниже вашей (кроме офицера снабжения)."
            />
        </TooltipBody>
    </Tooltip>
)
ChangeRoleCannotChangeRoleExceptTreasurersTooltip.id = 'change-role-cannot-change-role-except-treasurers-body'


export const ChangeRoleCannotChangeRoleTooltip = () => (
    <Tooltip id={ChangeRoleCannotChangeRoleTooltip.id}>
        <TooltipBody>
            <FormattedMessage
                id="clanmanagement.tooltips.change_role_cannot_change_role_body"
                defaultMessage="Вы можете изменить должность только игроков в должности ниже вашей."
            />
        </TooltipBody>
    </Tooltip>
)
ChangeRoleCannotChangeRoleTooltip.id = 'change-role-cannot-change-role-body'


export const RemoveMembersZeroPlayersSelectedTooltip = () => (
    <Tooltip id={RemoveMembersZeroPlayersSelectedTooltip.id}>
        <TooltipBody>
            <FormattedMessage
                id="clanmanagement.tooltips.remove_members_zero_players_selected_body"
                defaultMessage="Выберите одного или нескольких игроков, чтобы исключить из клана."
            />
        </TooltipBody>
    </Tooltip>
)
RemoveMembersZeroPlayersSelectedTooltip.id = 'remove-members-zero-players-selected-tooltip'


export const RemoveMembersCannotRemoveMembersExceptTreasurersTooltip = () => (
    <Tooltip id={RemoveMembersCannotRemoveMembersExceptTreasurersTooltip.id}>
        <TooltipBody>
            <FormattedMessage
                id="clanmanagement.tooltips.remove_members_cannot_remove_members_except_treasurers_body"
                defaultMessage="Вы можете исключить из клана только игроков в должности ниже вашей (кроме офицера снабжения)."
            />
        </TooltipBody>
    </Tooltip>
)
RemoveMembersCannotRemoveMembersExceptTreasurersTooltip.id = 'remove-members-cannot-remove-members-except-treasurers-body'


export const RemoveMembersCannotRemoveMembersTooltip = () => (
    <Tooltip id={RemoveMembersCannotRemoveMembersTooltip.id}>
        <TooltipBody>
            <FormattedMessage
                id="clanmanagement.tooltips.remove_members_cannot_remove_members_body"
                defaultMessage="Вы можете исключить из клана только игроков в должности ниже вашей."
            />
        </TooltipBody>
    </Tooltip>
)
RemoveMembersCannotRemoveMembersTooltip.id = 'remove-members-cannot-remove-members-body'



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/MembersControlBlock/tooltips.js